import styled from "styled-components";
import BigInfoBox from "../../BigInfoBox";
import Context from "../../../../../Context";
import { useContext } from "react";
import { GoComment, GoLocation, GoPeople } from "react-icons/go";
import { BsPeople } from "react-icons/bs";
import { GrDocument } from "react-icons/gr";
import { MdMap } from "react-icons/md";
import { RiMap2Line } from "react-icons/ri";
import { IoDocumentsOutline } from "react-icons/io5";
import { CgUserList } from "react-icons/cg";
import { BiConfused } from "react-icons/bi";
import BigInfoBoxSquare from "../../BigInfoBoxSquare";

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
  flex: 1;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;

  @media (max-width: 900px) {
    /* flex-direction: column; */
  }
`;

export default function InfoListForManagementGridView({ data }) {
  const { themeState } = useContext(Context);

  if (!data) data = {};

  return (
    <List>
      <Row>
        {/* <BigInfoBox
          icon={<GoLocation />}
          primaryText={data.sitesCount}
          secondaryText="Sites"
        /> */}
        <BigInfoBoxSquare
          icon={<GoLocation />}
          primaryText={data.activeSitesCount}
          secondaryText="Sites Actifs"
        />

        <BigInfoBoxSquare
          icon={<GoPeople />}
          primaryText={data.activeEmployeesCount}
          secondaryText="Employés Actifs"
        />
      </Row>

      {/* <Row>
        <BigInfoBox
          icon={<GoPeople />}
          primaryText={data.employeesCount}
          secondaryText="Employés"
        />
      </Row> */}

      {/* <Row>
        <BigInfoBox
          icon={<IoDocumentsOutline />}
          primaryText={data.rolesCount}
          secondaryText="Roles"
        />
        <BigInfoBox
          icon={<RiMap2Line />}
          primaryText={data.zonesCount}
          secondaryText="Zones"
        />
      </Row> */}

      {/* <Row> */}

      {/* <BigInfoBox
          icon={<BiConfused />}
          primaryText={data.disputesToday}
          secondaryText="Conflits d'aujourd'hui"
        /> */}
      {/* </Row> */}
      <Row>
        <BigInfoBoxSquare
          icon={<CgUserList />}
          primaryText={data.absencesToday}
          secondaryText="Absences (Aujourd'hui)"
        />
        <BigInfoBoxSquare
          icon={<GoComment />}
          primaryText={data.commentsOfLastSevenDays}
          secondaryText={`Commentaires (7 Jours)`}
        />
      </Row>
    </List>
  );
}
